export default __webpack_public_path__ + "static/media/topicHiker2.4b089757.png";